/**
 * Feel Awsm · Detox Essenz Funnel
 * Scoped to #feelawsm-detox-funnel (Shopify-safe, Dawn pattern).
 * Add-to-cart mirrors assets/product-form.js (sections in POST, XHR for selling plans, renderContents + open).
 * v1 — initial build, sage forest-spa palette, .det- prefix, liver-load calculator.
 */
(function () {
    "use strict";

    var ROOT_ID = "feelawsm-detox-funnel";
    var root = document.getElementById(ROOT_ID);
    if (!root) {
        return;
    }
    if (root.dataset.detInit === "1") {
        return;
    }
    root.dataset.detInit = "1";
    document.documentElement.classList.add("det-js");

    var funnelCfg = {};
    var cfgEl = document.getElementById("FeelawsmDetoxFunnelConfig");
    if (cfgEl && cfgEl.textContent) {
        try {
            funnelCfg = JSON.parse(cfgEl.textContent);
        } catch (e) {
            funnelCfg = {};
        }
    }
    var addingLabel =
        funnelCfg && typeof funnelCfg.addingLabel === "string" && funnelCfg.addingLabel
            ? funnelCfg.addingLabel
            : "Adding…";

    // ============ SCROLL REVEAL ============
    var observerOptions = { threshold: 0.1, rootMargin: "0px 0px -40px 0px" };
    var revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                entry.target.classList.add("det-in");
                revealObserver.unobserve(entry.target);
            }
        });
    }, observerOptions);
    root.querySelectorAll(".det-reveal").forEach(function (el) {
        revealObserver.observe(el);
    });

    // ============ FAQ ACCORDION (<details>, only one open at a time) ============
    var faqItems = root.querySelectorAll(".det-faq-item");
    faqItems.forEach(function (item) {
        item.addEventListener("toggle", function () {
            if (item.open) {
                faqItems.forEach(function (other) {
                    if (other !== item && other.open) {
                        other.open = false;
                    }
                });
            }
        });
    });

    // ============ STICKY CART SHOW/HIDE ============
    var sticky = root.querySelector("#det-sticky");
    var hero = root.querySelector(".det-hero");
    var ticking = false;
    function setStickyPadding(show) {
        root.classList.toggle("det-has-sticky", !!show);
    }
    window.addEventListener("scroll", function () {
        if (!ticking) {
            window.requestAnimationFrame(function () {
                var y = window.pageYOffset || document.documentElement.scrollTop;
                var threshold = hero ? (hero.offsetTop + hero.offsetHeight - 120) : 600;
                if (sticky) {
                    if (y > threshold) {
                        sticky.classList.add("det-show");
                        setStickyPadding(true);
                    } else {
                        sticky.classList.remove("det-show");
                        setStickyPadding(false);
                    }
                }
                ticking = false;
            });
            ticking = true;
        }
    }, { passive: true });

    // ============ SMOOTH ANCHOR SCROLL (offset for sticky bar) ============
    root.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
        anchor.addEventListener("click", function (e) {
            var href = anchor.getAttribute("href");
            if (!href || href.length < 2 || href === "#") {
                return;
            }
            var target = document.querySelector(href);
            if (!target) {
                return;
            }
            e.preventDefault();
            var top = target.getBoundingClientRect().top + window.pageYOffset - 60;
            window.scrollTo({ top: top, behavior: "smooth" });
        });
    });

    // ============ INGREDIENTS "SHOW ALL" TOGGLE ============
    var blocksToggle = root.querySelector(".det-blocks-toggle button");
    var blocksWrap = root.querySelector(".det-blocks");
    if (blocksToggle && blocksWrap) {
        blocksToggle.addEventListener("click", function () {
            var open = blocksWrap.classList.toggle("det-show-all");
            blocksToggle.textContent = open
                ? (blocksToggle.dataset.lessLabel || "Show fewer ingredients ↑")
                : (blocksToggle.dataset.moreLabel || "See all 12 ingredients ↓");
        });
    }

    // ============ LIVER FUNCTION DECLINE CHART ============
    // (v2 — replaced Chart.js with inline SVG · 0 KB JS, 0 network requests)

    // ============ LIVER-LOAD CALCULATOR ============
    // Score = "Liver Wellness" out of 100. Higher is better.
    // Result text (cat / msg / boost per tier) is read from FeelawsmDetoxCalcConfig
    // so Translate & Adapt can localise it.
    var calcCfg = {};
    var calcCfgEl = document.getElementById("FeelawsmDetoxCalcConfig");
    if (calcCfgEl && calcCfgEl.textContent) {
        try {
            calcCfg = JSON.parse(calcCfgEl.textContent);
        } catch (e) {
            calcCfg = {};
        }
    }
    function calcText(key, fallback) {
        if (calcCfg && typeof calcCfg[key] === "string" && calcCfg[key]) {
            return calcCfg[key];
        }
        return fallback;
    }

    var calcBtn = root.querySelector(".det-calc-btn");
    if (calcBtn) {
        calcBtn.addEventListener("click", function () {
            var ageInput = root.querySelector("#det-calc-age");
            var age = parseInt(ageInput && ageInput.value, 10) || 35;
            var bloat = (root.querySelector('input[name="det-bloat"]:checked') || {}).value || "sometimes";
            var fog = (root.querySelector('input[name="det-fog"]:checked') || {}).value || "weekly";
            var alc = (root.querySelector('input[name="det-alc"]:checked') || {}).value || "1-3";
            var stressEl = root.querySelector("#det-calc-stress");
            var stress = (stressEl && stressEl.value) || "medium";
            var supp = (root.querySelector('input[name="det-supp"]:checked') || {}).value || "no";

            var base = 100 - Math.max(0, (age - 30) * 1.2);
            if (bloat === "sometimes") base -= 8;
            if (bloat === "daily") base -= 18;
            if (fog === "weekly") base -= 7;
            if (fog === "daily") base -= 15;
            if (alc === "1-3") base -= 5;
            if (alc === "4+") base -= 12;
            if (stress === "medium") base -= 7;
            if (stress === "high") base -= 15;
            if (supp === "yes") base -= 3;
            base = Math.max(15, Math.min(100, Math.round(base)));

            var scoreEl = root.querySelector("#det-result-score");
            var catEl = root.querySelector("#det-result-cat");
            var msgEl = root.querySelector("#det-result-msg");
            var boostEl = root.querySelector("#det-boost");
            var fillEl = root.querySelector("#det-prog-fill");
            var panel = root.querySelector("#det-result");

            if (scoreEl) scoreEl.textContent = base + "%";
            if (fillEl) {
                fillEl.style.width = base + "%";
                if (base >= 75) fillEl.style.background = "linear-gradient(90deg,#3A6B4A,#5A8A6A)";
                else if (base >= 55) fillEl.style.background = "linear-gradient(90deg,#C9A96E,#E8D5AA)";
                else fillEl.style.background = "linear-gradient(90deg,#B87878,#D4A8A8)";
            }

            var cat, msg, boost;
            if (base >= 80) {
                cat = calcText("lowCat",   "🟢 Low Burden");
                msg = calcText("lowMsg",   "Your liver appears to be coping well.");
                boost = calcText("lowBoost", "💡 Recommendation: 1 month of Detox Essenz, maintenance dose.");
            } else if (base >= 60) {
                cat = calcText("mildCat",   "🟡 Mild Burden");
                msg = calcText("mildMsg",   "Your liver is showing the first signs of overload.");
                boost = calcText("mildBoost", "💡 Recommendation: 1 month of Detox Essenz, 2 capsules daily.");
            } else if (base >= 40) {
                cat = calcText("sigCat",   "🟠 Significant Burden");
                msg = calcText("sigMsg",   "Your liver is clearly under strain.");
                boost = calcText("sigBoost", "💡 Recommendation: Start the 3-month pack.");
            } else {
                cat = calcText("highCat",   "🔴 High Burden");
                msg = calcText("highMsg",   "Your score suggests significant, daily liver overload.");
                boost = calcText("highBoost", "💡 Recommendation: 3-month pack with subscription.");
            }
            if (catEl) catEl.textContent = cat;
            if (msgEl) msgEl.textContent = msg;
            if (boostEl) boostEl.textContent = boost;
            if (panel) {
                panel.classList.add("det-show");
                panel.scrollIntoView({ behavior: "smooth", block: "nearest" });
            }
        });
    }

    // ============ CART DRAWER INTEGRATION (Dawn pattern — mirrors product-form.js) ============
    function getCartUi() {
        return document.querySelector("cart-notification") || document.querySelector("cart-drawer");
    }

    function getCartAddUrl() {
        var cartAddPath =
            typeof routes !== "undefined" && routes.cart_add_url
                ? String(routes.cart_add_url)
                : "/cart/add";
        if (cartAddPath.charAt(0) === "/" && cartAddPath.indexOf("cart") !== -1) {
            return cartAddPath.replace(/\/cart\/add\/?$/, "/cart/add.js");
        }
        return "/cart/add.js";
    }

    function parseQuantity(btn) {
        var q = parseInt(btn.getAttribute("data-quantity"), 10);
        if (!isNaN(q) && q > 0) {
            return q;
        }
        return 1;
    }

    function fetchSectionHtmlForCart(cart, data, doRender) {
        if (data.sections || !cart || typeof routes === "undefined" || !routes.cart_url) {
            doRender(data);
            return Promise.resolve();
        }
        var sectionIds = cart.getSectionsToRender().map(function (s) {
            return s.id;
        });
        return Promise.all(
            sectionIds.map(function (id) {
                return fetch(routes.cart_url + "?section_id=" + id, { cache: "no-store" }).then(function (r) {
                    return r.text();
                });
            })
        )
            .then(function (htmls) {
                var sections = {};
                sectionIds.forEach(function (id, i) {
                    sections[id] = htmls[i];
                });
                doRender(Object.assign({}, data, { sections: sections }));
            })
            .catch(function () {
                doRender(data);
            });
    }

    root.querySelectorAll(".js-feelawsm-funnel-atc").forEach(function (btn) {
        btn.addEventListener("click", function (e) {
            e.preventDefault();
            if (btn.getAttribute("aria-disabled") === "true") {
                return;
            }

            var cart = getCartUi();
            var vid = parseInt(btn.getAttribute("data-variant-id"), 10);
            var spRaw = btn.getAttribute("data-selling-plan") || "";
            var quantity = parseQuantity(btn);

            if (!vid || isNaN(vid)) {
                alert("Missing variant");
                return;
            }

            var sellingPlanId = null;
            if (String(spRaw).trim() !== "") {
                var spNum = parseInt(spRaw, 10);
                if (!isNaN(spNum)) {
                    sellingPlanId = spNum;
                }
            }

            var item = { id: vid, quantity: quantity };
            if (sellingPlanId != null) {
                item.selling_plan = sellingPlanId;
            }

            var body = { items: [item] };
            if (cart) {
                if (typeof cart.setActiveElement === "function") {
                    cart.setActiveElement(document.activeElement);
                }
                if (sellingPlanId == null) {
                    body.sections = cart.getSectionsToRender().map(function (section) {
                        return section.id;
                    });
                    body.sections_url = window.location.pathname;
                }
            }

            var addUrl = getCartAddUrl();
            var bodyString = JSON.stringify(body);

            // Optional: target a child element for the "Adding…" label (so the card's
            // outer layout stays intact when the whole card is the clickable surface).
            var loadingEl = btn;
            var loadingSel = btn.getAttribute("data-loading-element");
            if (loadingSel) {
                var found = btn.querySelector(loadingSel);
                if (found) {
                    loadingEl = found;
                }
            }
            var previousHtml = loadingEl.innerHTML;
            loadingEl.innerHTML = "";
            loadingEl.appendChild(document.createTextNode(addingLabel));
            btn.classList.add("feelawsm-funnel-atc--loading");
            btn.setAttribute("aria-busy", "true");
            btn.setAttribute("aria-disabled", "true");

            var cartAddPromise =
                sellingPlanId != null
                    ? new Promise(function (resolve, reject) {
                          var xhr = new XMLHttpRequest();
                          xhr.open("POST", addUrl, true);
                          xhr.setRequestHeader("Content-Type", "application/json");
                          xhr.setRequestHeader("Accept", "application/json");
                          xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
                          xhr.onload = function () {
                              if (xhr.status < 200 || xhr.status >= 400) {
                                  reject(new Error("Cart add failed: " + xhr.status));
                                  return;
                              }
                              try {
                                  resolve(JSON.parse(xhr.responseText));
                              } catch (err) {
                                  reject(err);
                              }
                          };
                          xhr.onerror = function () {
                              reject(new Error("Cart add network error"));
                          };
                          xhr.send(bodyString);
                      })
                    : fetch(addUrl, {
                          method: "POST",
                          headers: {
                              "Content-Type": "application/json",
                              Accept: "application/json",
                              "X-Requested-With": "XMLHttpRequest",
                          },
                          body: bodyString,
                      }).then(function (response) {
                          if (!response.ok) {
                              throw new Error("Cart add failed: " + response.status);
                          }
                          return response.json();
                      });

            cartAddPromise
                .then(function (response) {
                    if (response.status) {
                        if (typeof publish === "function" && window.PUB_SUB_EVENTS) {
                            publish(window.PUB_SUB_EVENTS.cartError, {
                                source: "feelawsm-detox-funnel",
                                productVariantId: String(vid),
                                errors: response.errors || response.description,
                                message: response.message,
                            });
                        }
                        var desc = (response.description || response.message || "Could not add to cart").toString();
                        alert(desc);
                        return;
                    }

                    if (!cart) {
                        if (typeof routes !== "undefined" && routes.cart_url) {
                            window.location.href = routes.cart_url;
                        } else {
                            window.location.href = "/cart";
                        }
                        return;
                    }

                    if (typeof publish === "function" && window.PUB_SUB_EVENTS) {
                        publish(window.PUB_SUB_EVENTS.cartUpdate, {
                            source: "feelawsm-detox-funnel",
                            productVariantId: String(vid),
                            cartData: response,
                        });
                    }
                    window.dispatchEvent(new CustomEvent("cart:updated", { bubbles: true }));

                    var doRender = function (data) {
                        cart.renderContents(data);
                    };

                    if (cart.classList && cart.classList.contains("is-empty")) {
                        cart.classList.remove("is-empty");
                    }

                    return fetchSectionHtmlForCart(cart, response, doRender);
                })
                .catch(function (err) {
                    console.warn("[feelawsm-funnel]", err);
                    var msg = (err && err.message) || "Could not add to cart";
                    alert(msg);
                })
                .finally(function () {
                    loadingEl.innerHTML = previousHtml;
                    btn.classList.remove("feelawsm-funnel-atc--loading");
                    btn.removeAttribute("aria-busy");
                    btn.removeAttribute("aria-disabled");
                });
        });
    });
})();
